import { render, staticRenderFns } from "./ContactPopover.vue?vue&type=template&id=9da21778&scoped=true&"
import script from "./ContactPopover.vue?vue&type=script&lang=ts&"
export * from "./ContactPopover.vue?vue&type=script&lang=ts&"
import style0 from "./ContactPopover.vue?vue&type=style&index=0&id=9da21778&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da21778",
  null
  
)

export default component.exports